import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import ModalTambahAnggota from '../components/ModalTambahAnggota';
import ModalEditAnggota from '../components/ModalEditAnggota';
import ModalNonaktifkanGenerasi from '../components/ModalNonaktifkanGenerasi';
import ModalImportAnggota from '../components/ModalImportAnggota';
import { FaEdit, FaTrash, FaPlus, FaUserSlash, FaFileImport } from 'react-icons/fa';
import Swal from 'sweetalert2';

const DataAnggota = () => {
  const [dataAnggota, setDataAnggota] = useState([]);
  const [isTambahModalOpen, setIsTambahModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isNonaktifkanModalOpen, setIsNonaktifkanModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false); // ⬅️ NEW
  const [selectedAnggota, setSelectedAnggota] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTambah, setLoadingTambah] = useState(false);

  // Fetch hanya anggota dengan status 'aktif'
  const fetchDataAnggota = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota?status=aktif`);
      if (!response.ok) {
        throw new Error('Gagal mengambil data anggota');
      }
      const data = await response.json();
      const sortedData = data.sort((a, b) => a.id - b.id);
      setDataAnggota(sortedData);
    } catch (err) {
      Swal.fire('Error', err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSimpanAnggota = async (dataAnggotaBaru) => {
    setLoadingTambah(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataAnggotaBaru),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Gagal menyimpan anggota');
      }

      fetchDataAnggota();
      return 'Anggota berhasil ditambahkan!';
    } catch (err) {
      throw err;
    } finally {
      setLoadingTambah(false);
    }
  };

  const handleUpdateAnggota = async (id, updatedData) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Gagal mengupdate anggota');
      }

      fetchDataAnggota();
      return 'Anggota berhasil diperbarui!';
    } catch (err) {
      throw err;
    }
  };

  const handleDeleteAnggota = async (id) => {
    const result = await Swal.fire({
      title: 'Apakah Anda yakin?',
      text: 'Data anggota yang dihapus tidak dapat dikembalikan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus!',
      cancelButtonText: 'Batal'
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Gagal menghapus anggota');
        }

        fetchDataAnggota();
        Swal.fire('Terhapus!', 'Anggota berhasil dihapus.', 'success');
      } catch (err) {
        Swal.fire('Gagal!', err.message, 'error');
      }
    }
  };

  const handleOpenTambahModal = () => setIsTambahModalOpen(true);
  const handleCloseTambahModal = () => setIsTambahModalOpen(false);

  const handleOpenEditModal = (anggota) => {
    setSelectedAnggota(anggota);
    setIsEditModalOpen(true);
  };
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedAnggota(null);
  };

  const handleOpenNonaktifkanModal = () => setIsNonaktifkanModalOpen(true);
  const handleCloseNonaktifkanModal = () => setIsNonaktifkanModalOpen(false);

  // ⬅️ NEW: Handler untuk Import Modal
  const handleOpenImportModal = () => setIsImportModalOpen(true);
  const handleCloseImportModal = () => setIsImportModalOpen(false);

  const handleSuccessNonaktifkan = () => {
    fetchDataAnggota();
  };

  const handleSuccessImport = () => {
    fetchDataAnggota();
  };

  useEffect(() => {
    fetchDataAnggota();
  }, []);

  return (
    <Layout title="Data Anggota">
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">Data Anggota Aktif</p>
          <div style={{ display: 'flex', gap: '10px', padding: '10px' }}>
            {/* ⬅️ NEW: Tombol Import */}
            <button className="button is-success" onClick={handleOpenImportModal}>
              <span className="icon"><FaFileImport /></span>
              <span>Import Excel</span>
            </button>
            
            <button className="button is-warning" onClick={handleOpenNonaktifkanModal}>
              <span className="icon"><FaUserSlash /></span>
              <span>Nonaktifkan Generasi</span>
            </button>
            
            <button className="button is-info" onClick={handleOpenTambahModal}>
              <span className="icon"><FaPlus /></span>
              <span>Tambah Anggota</span>
            </button>
          </div>
        </header>
        <div className="card-content">
          {loading && <p>Loading...</p>}
          {!loading && (
            <div className="table-container">
              <table className="table is-fullwidth is-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Kode Anggota</th>
                    <th>NIS</th>
                    <th>Nama Lengkap</th>
                    <th>Kelas/Jabatan</th>
                    <th>Tahun Masuk</th>
                    <th>Status</th>
                    <th>Alamat</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {dataAnggota.map((anggota, index) => (
                    <tr key={anggota.id}>
                      <td>{index + 1}</td>
                      <td>{anggota.kode_anggota}</td>
                      <td>{anggota.nis}</td>
                      <td>{anggota.nama_lengkap}</td>
                      <td>{anggota.kelas}</td>
                      <td>{anggota.tahun_masuk || '-'}</td>
                      <td>
                        <span className="tag is-success">Aktif</span>
                      </td>
                      <td>{anggota.alamat}</td>
                      <td>
                        <button className="button is-info is-small" onClick={() => handleOpenEditModal(anggota)}>
                          <span className="icon"><FaEdit /></span>
                        </button>
                        <button className="button is-danger is-small ml-2" onClick={() => handleDeleteAnggota(anggota.id)}>
                          <span className="icon"><FaTrash /></span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <ModalTambahAnggota
        isOpen={isTambahModalOpen}
        onClose={handleCloseTambahModal}
        onSimpan={handleSimpanAnggota}
        loading={loadingTambah}
      />

      {selectedAnggota && (
        <ModalEditAnggota
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          onUpdate={handleUpdateAnggota}
          anggotaData={selectedAnggota}
        />
      )}

      <ModalNonaktifkanGenerasi
        isOpen={isNonaktifkanModalOpen}
        onClose={handleCloseNonaktifkanModal}
        onSuccess={handleSuccessNonaktifkan}
      />

      {/* ⬅️ NEW: Modal Import */}
      <ModalImportAnggota
        isOpen={isImportModalOpen}
        onClose={handleCloseImportModal}
        onSuccess={handleSuccessImport}
      />
    </Layout>
  );
};

export default DataAnggota;